// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_header__filters__NNo3A {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  flex-wrap: wrap;
  align-items: center;
}

.styles_header__dateRangeFilter__4PrSx {
  width: 350px;
  display: flex;
  gap: 1rem;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/PreviaINSS/ModalAnalisar/StepsAnalisar/GerarRelatorioCompleto/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB","sourcesContent":[".header__filters {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.header__dateRangeFilter {\n  width: 350px;\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header__filters": `styles_header__filters__NNo3A`,
	"header__dateRangeFilter": `styles_header__dateRangeFilter__4PrSx`
};
export default ___CSS_LOADER_EXPORT___;
